export default __webpack_public_path__ + "static/media/arielLogo.e2ee74e5.png";